module.exports = __webpack_public_path__ + "2229281de929b2a537217baf14a1d194.png";